/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/View', 'bootstrap/js/tab'], function($, View) {
    var TEMP_TAB_CLASS = 'default-tab-active';

    var TAB_PRODUCT_DETAILS = '#product-details';
    var TAB_PRICING_DELIVERY = '#pricing-delivery';
    var TAB_UPLOAD = '#upload';

    return View.extend({
        initialize: function(options) {
            var _this = this;

            this.pricingInitiated = false;

            this.$tabsContainer = this.$el.find(options.tabsContainer);
            this.$tabsContent = this.$el.find(options.tabsContent);

            if (options.initPricingOnTabChange) {
                this.$el.on('show.bs.tab', TAB_PRICING_DELIVERY + ',' + TAB_UPLOAD, function() {
                    _this.initPricing();
                });
            }

            this.$el.one('show.bs.tab', function() {
                _this._clearTabInitialCss();
            });

            var $activeTab = this.$tabsContainer.find(options.activeTab);
            if ($activeTab.length === 1) {
                $activeTab.tab('show');
            }
        },

        initPricing: function() {
            if (!this.pricingInitiated) {
                this.model.trigger('pricing:init');
                this.pricingInitiated = true;
            }
        },

        // Remove default css styles and let tabs component handle displaying the tabs
        _clearTabInitialCss: function() {
            this.$tabsContainer.removeClass(TEMP_TAB_CLASS);
            this.$tabsContent.removeClass(TEMP_TAB_CLASS);
        }
    });
});
